import React from "react";

class NodeActionGrid {
  title = 'Lista de Actions';
  columns = [
    {
      Header: "Node UUID",
      accessor: "nodeSource.uuid"
    },
    {
      Header: "Momento",
      accessor: "actionMoment"
    },
    {
      Header: "Tempo em UP em ms",
      accessor: "ttlInUpInMilliseconds"
    },
  ];
  endpoint = "cloud/v1/actions";
}

export default NodeActionGrid;



// WEBPACK FOOTER //
// ./src/gateways/node/NodeActionGrid.js